module.exports = __webpack_public_path__ + "images/emoji/gift.7083f2a03a81c0a5c4a1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/gift.png
// module id = Fq4b
// module chunks = 24